module.exports = __webpack_public_path__ + "static/img/1152_phase_function_Paper_PointsHejduk_Prediction.4131cd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1152_phase_function_Paper_PointsHejduk_Prediction.png
// module id = fZpK
// module chunks = 0